import { useAtom } from "jotai";
import { FC } from "react";

import { Background } from "@/components/Layout/Background/Background";
import { Footer } from "@/components/Layout/Footer/Footer";
import { WelcomeEsimContent } from "@/components/Welcome/WelcomeContent/WelcomeEsimContent";
import { WelcomeHeader } from "@/components/Welcome/WelcomeHeader/WelcomeHeader";
import { useLoginRedirect } from "@/hooks/useLoginRedirect";
import { destinationAtom } from "@/utils/atoms";

export const WelcomeEsim: FC = () => {
  // Set the destination after a possible authentication redirect to the
  // add-device flow of the portal.
  const [, setDestination] = useAtom(destinationAtom);
  setDestination("/portal/add-device/1/sim-selection");
  const isRedirecting = useLoginRedirect();

  return isRedirecting ? null : (
    <Background>
      <WelcomeHeader />
      <WelcomeEsimContent />
      <Footer className="welcome-screen" />
    </Background>
  );
};
